/**
 * Obvious function name. deletes the contact that has been selected
 *
 * @param id
 * @param name
 * @param course_description
 * @param course_component_description
 * @returns {boolean}
 */
function delete_reschedule_contact(id, name, course_description, course_component_description) {
    var $ = jQuery.noConflict();
    name = decodeURI(name);
    course_description = decodeURI(course_description);
    course_component_description = decodeURI(course_component_description);
    confirm("Weet u zeker dat u \""+name+"\" niet langer opnieuw wilt plannen voor het onderdeel \""+course_component_description+"\" van de cursus \""+course_description+"\"?", function() {
        $('body').isLoading('dark');
        $.ajax({
            url: "/reschedule/delete",
            data: {id:id},
            type: "POST",
            success: function(data) {
                reload_location_if_needed();
                $('body').doneLoading();
            },
            error: function(e) {
                $('body').doneLoading();
                squde_flash("Er ging helaas iets mis.", "alert");
            }
        });
    });
    return false;
}

/**
 * This function opens the reschedule-popup, where you can see notes and stuff.
 *
 * @param id
 * @param vars
 * @returns {boolean}
 */
function view_reschedule_contact(id) {
    var $ = jQuery.noConflict();

    $.squdeAjaxPopup({
        url: '/reschedule/view/'+id,
        onOpen: function(elm, popup) {
            //Respond the the (only) form on this screen and tell it what to do when it
            // 1) Responds well
            // 2) Returns errors
            // 3) Ran, no matter the outcome
            elm.find('form').ajaxFormSubmit(function(data){
                $('body').doneLoading();
                reload_location_if_needed();
            }, function(xhr, status, error) {
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.","alert");
            }.bind([elm,popup]), function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}